import { Component, Inject, OnInit } from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import { NavBarComponent } from 'src/app/nav-bar/nav-bar.component';
import { PinManagerService } from 'src/app/services/pin-manager.service';
import { catchError, throwError } from 'rxjs';


@Component({
    selector: 'app-new-delete-pin',
    templateUrl: './new-delete-pin.component.html',
    styleUrls: ['./new-delete-pin.component.css'],
    standalone: false
})
export class NewDeletePinComponent implements OnInit {

  pinId:number = null;
  isBulkDelete:boolean = false;

  constructor(@Inject(MAT_DIALOG_DATA) public data: any,
      public deletePinDialog: MatDialogRef<NewDeletePinComponent>,
      public nav: NavBarComponent,
      private pinManagerService: PinManagerService,
  ) {
  }
  ngOnInit(): void {
   if(this.data){
    this.pinId = this.data.pinId;
    this.isBulkDelete = this.data.isBulkDelete;
   }
  }


  close(): void {
    this.deletePinDialog.close({"option": "cancel"});
  }
  deleteItemById(){

    this.nav.toggleLoading(true);
    if(this.data.isBulkDelete == true){
      this.deletePinDialog.close({"option": "delete"});
    }else{
      this.pinManagerService.deletePinById(this.pinId).pipe(
        catchError(error => {
          console.error(error);
          return throwError(() => error);
        })
    ).subscribe(() => {
      this.deletePinDialog.close({"option": "delete"});
      this.nav.toggleLoading(false);
    });
  }
    }
  
}
